// extracted by mini-css-extract-plugin
module.exports = {"frame":"VideoPreview_frame__1lJv8","video":"VideoPreview_video__3ySyq","badge":"VideoPreview_badge__2DgiC"};